import { useAtom } from 'jotai';
import cn from 'classnames';

import { isDisableHelpersAtom } from '../../../../store/index.atom';
import KeyPressLayer from '../../Layer/KeyPressLayer';

import * as Styled from './index.styles';
import MobilePageMoveButton from './MobilePageMoveButton';
import MobliePageIndicator from './MobilePageIndicator';

interface Props {
  updatePrevThumbnails?: (page: number) => void;
  updateNextThumbnails?: (page: number) => void;
  openDrawer: () => void;
  totalPage: number;
  ctaFormPage?: number;
  isMoveCtaFormPageRequirements: boolean;
  isNextPageButtonDisabled?: boolean;
  isMobileLandscape: boolean;
}

const MobilePageNavigationButton = ({
  updatePrevThumbnails,
  updateNextThumbnails,
  openDrawer,
  totalPage,
  ctaFormPage,
  isMoveCtaFormPageRequirements,
  isNextPageButtonDisabled,
  isMobileLandscape,
}: Props) => {
  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  return (
    <KeyPressLayer
      updateNextThumbnails={updateNextThumbnails}
      updatePrevThumbnails={updatePrevThumbnails}
      totalPage={totalPage}
      isNextPageButtonDisabled={isNextPageButtonDisabled}
    >
      <Styled.PageNavigationButton
        className={cn({
          disabled: isDisableHelpers,
        })}
        onClick={() => {
          if (isDisableHelpers) {
            setIsDisableHelpers(false);
            return;
          }
        }}
      >
        <MobilePageMoveButton
          variant="prev"
          totalPage={totalPage}
          updatePrevThumbnails={updatePrevThumbnails}
        />
        <MobliePageIndicator
          totalPage={totalPage}
          openDrawer={openDrawer}
          ctaFormPage={ctaFormPage}
          isMoveCtaFormPageRequirements={isMoveCtaFormPageRequirements}
          isMobileLandscape={isMobileLandscape}
        />
        <MobilePageMoveButton
          variant="next"
          totalPage={totalPage}
          isNextPageButtonDisabled={isNextPageButtonDisabled}
          updateNextThumbnails={updateNextThumbnails}
        />
      </Styled.PageNavigationButton>
    </KeyPressLayer>
  );
};

export default MobilePageNavigationButton;
